import React from "react";

import { IAttendance } from "../../pages/medicalRecord/components/attendanceRecord/AttendanceRecord";
import {
  AttendanceCardContainer,
  BoxDetail,
  ContentCard,
  Detail,
  Icon,
} from "../../pages/medicalRecord/components/attendanceRecord/AttendanceRecord.styled";
import Printer from "../../assets/imgs/printer.svg";
import ArrowRight from "../../assets/imgs/arrow-right.svg";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import { Paths } from "../../enums/Paths";

export interface AttendanceCardProps {
  data: IAttendance;
  pessoa: any;
  agendamento: any;
  openModal: (value: boolean) => void;
}

const AttendanceCard: React.FC<AttendanceCardProps> = ({
  data,
  agendamento,
  pessoa,
  openModal
}) => {
  const navigate = useNavigate();
  const { horario, id, nomeProfissional, tipoProfissional } = data;

  const goTo = (route: string) => {
    navigate(route, { state: {atendimentoId: id, id: id, finalizado: true, pessoa: pessoa, agendamento: {...agendamento, tipoProfissional: tipoProfissional} }});
  };

  return (
    <AttendanceCardContainer>
      <ContentCard bold>{moment(horario).format('DD/MM/YYYY')}</ContentCard>
      <ContentCard>{tipoProfissional}</ContentCard>
      <ContentCard>{nomeProfissional}</ContentCard>
      <ContentCard>
        <BoxDetail onClick={() => goTo(Paths.RegistroAtendimento)}>
          <Detail>VER DETALHES</Detail>
          <Icon src={ArrowRight} width={10} height={10} />
        </BoxDetail>
      </ContentCard>
      <ContentCard onClick={() => openModal(true)}>
        <Icon width={20} height={20} src={Printer} />
      </ContentCard>
    </AttendanceCardContainer>
  );
};

export default AttendanceCard;
